/**
 * Define all of your application routes here
 * for more information on routes, see the
 * official documentation https://router.vuejs.org/en/
 */
import store from '../store'
export default [
  {
    path: '*',
    meta: {
      name: '',
      requiresAuth: true
    },
    redirect: {
      path: '/dashboard'
    }
  },
  // This  allows you to have pages apart of the app but no rendered inside the dash
  {
    path: '/',
    meta: {
      name: '',
      requiresAuth: false
    },
    component: () =>
      import(/* webpackChunkName: "routes" */ `@/views/LoginHome.vue`),
    // redirect if already signed in
    beforeEnter: (to, from, next) => {
      if (store.getters.authorized) {
        next('/dashboard')
      } else {
        next()
      }
    },
    children: [
      {
        path: '',
        component: () => import(`@/components/LoginForm.vue`)
      }
    ]
  },
  // add any extra routes that you want rendered in the dashboard as a child below. Change toolbar names here
  {
    path: '/dashboard',
    meta: {
      name: 'Dashboard View',
      requiresAuth: true
    },
    component: () => import(`@/views/DashboardView.vue`),
    children: [
      {
        path: '',
        name: 'Dashboard',
        component: () => import(`@/components/DashViews/Dashboard.vue`)
      },
      {
        path: 'configuracion',
        name: 'Configuración',
        component: () => import(`@/components/DashViews/Configuraciones.vue`)
      },
      {
        path: 'administracion',
        name: 'Administración',
        component: () => import(`@/components/DashViews/Administracion.vue`)
      },
      {
        path: 'error-530',
        name: 'Error 530',
        component: () => import(`@/components/DashViews/Errores/Error530.vue`)
      },
      {
        path: 'error-531',
        name: 'Error 531',
        component: () => import(`@/components/DashViews/Errores/Error531.vue`)
      },
      {
        path: 'error-532',
        name: 'Error 532',
        component: () => import(`@/components/DashViews/Errores/Error532.vue`)
      },
      {
        path: 'error-533',
        name: 'Error 533',
        component: () => import(`@/components/DashViews/Errores/Error533.vue`)
      }
    ]
  }
]
